// extracted by mini-css-extract-plugin
export default {"donationList":"donationList__donationList--rD6ho","donationEntry":"donationList__donationEntry--UmeUM","name":"donationList__name--zXNXr","viewMore":"donationList__viewMore--heduq"};